const divModalDocCompany = {
  uploadSubmitError: 'Espere a que se carguen todos los archivos',
  uploadEmptyFileError: 'Se requiere como mínimo 1 archivo'
};

export default divModalDocCompany;
